module.exports = __webpack_public_path__ + "img/csinfo.b256dee9.png";